import React from 'react';
import { formatAdminProspectCentsLabel } from './adminProspectDisplay';
import {
  ProspectOwnerResponseCard,
  ProspectOwnerResponseField,
  ProspectProjectionProvenance,
  ProspectProjectionVerification,
} from './ProspectOwnerResponseShared';

function MoneyField({ label, cents, language, t }) {
  const text = formatAdminProspectCentsLabel(cents, language, t);
  if (text == null) return null;
  return <ProspectOwnerResponseField label={label}>{text}</ProspectOwnerResponseField>;
}

export default function ProspectOwnerProvidedFinancialCard({
  snapshot,
  language,
  t,
  busy,
  pending,
  error,
  onRequestChange,
  onConfirm,
  onCancel,
  onReload,
  hideTitle = false,
  embedded = false,
}) {
  if (!snapshot) {
    return (
      <ProspectOwnerResponseCard
        title={t('admin.prospection.section.ownerProvidedFinancial')}
        hideTitle={hideTitle}
        embedded={embedded}
      >
        <p className="text-sm text-slate-600">{t('admin.prospection.ownerResponse.financial.empty')}</p>
      </ProspectOwnerResponseCard>
    );
  }

  const expenses = snapshot.expenses || {};
  const otherDescription =
    typeof snapshot.otherExpensesDescription === 'string' && snapshot.otherExpensesDescription.trim()
      ? snapshot.otherExpensesDescription.trim()
      : null;

  return (
    <ProspectOwnerResponseCard
      title={t('admin.prospection.section.ownerProvidedFinancial')}
      hideTitle={hideTitle}
      embedded={embedded}
      fields={
        <>
          <MoneyField
            label={t('admin.prospection.ownerResponse.grossIncome')}
            cents={snapshot.grossAnnualIncomeCents}
            language={language}
            t={t}
          />
          <MoneyField
            label={t('admin.prospection.ownerResponse.municipalTaxes')}
            cents={expenses.municipalTaxesCents}
            language={language}
            t={t}
          />
          <MoneyField
            label={t('admin.prospection.ownerResponse.schoolTaxes')}
            cents={expenses.schoolTaxesCents}
            language={language}
            t={t}
          />
          <MoneyField
            label={t('admin.prospection.ownerResponse.insurance')}
            cents={expenses.insuranceCents}
            language={language}
            t={t}
          />
          <MoneyField
            label={t('admin.prospection.ownerResponse.heatingElectricity')}
            cents={expenses.heatingElectricityCents}
            language={language}
            t={t}
          />
          <MoneyField
            label={t('admin.prospection.ownerResponse.otherExpenses')}
            cents={expenses.otherExpensesCents}
            language={language}
            t={t}
          />
          {otherDescription ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.otherExpensesDescription')}>
              {otherDescription}
            </ProspectOwnerResponseField>
          ) : null}
          {snapshot.currency === 'CAD' ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.currency')}>
              {t('admin.prospection.ownerResponse.currency.CAD')}
            </ProspectOwnerResponseField>
          ) : null}
          {snapshot.period === 'annual_current' ? (
            <ProspectOwnerResponseField label={t('admin.prospection.ownerResponse.period')}>
              {t('admin.prospection.ownerResponse.period.annual_current')}
            </ProspectOwnerResponseField>
          ) : null}
          <ProspectProjectionProvenance provenance={snapshot.provenance} language={language} t={t} />
        </>
      }
    >
      <ProspectProjectionVerification
        section="latestOwnerProvidedFinancialSnapshot"
        verificationState={snapshot.verificationState}
        busy={busy}
        pending={pending}
        error={error}
        t={t}
        onRequestChange={onRequestChange}
        onConfirm={onConfirm}
        onCancel={onCancel}
        onReload={onReload}
      />
    </ProspectOwnerResponseCard>
  );
}
